import { useEffect, useRef } from "react";
import { useLearningCatalogue } from "../context";
import {
  SORT_OPTIONS,
  SORT_ORDER_RATING_DESC_INT,
  SORT_ORDER_NEXT_APPLICATION_INT,
} from "../constants";

export const useToolbar = () => {
  const {
    state,
    setSearchText,
    toggleListView,
    handleShowAdvancedFilter,
    setSortOrder,
  } = useLearningCatalogue();

  const {
    searchText,
    listView,
    sortOrder,
    showAdvancedFilter,
    displayRating,
    includeNextActivityInOverview,
    includeNextActivitySettingLoaded,
  } = state;

  const displayRatingInitialized = useRef(false);
  const prevDisplayRating = useRef(displayRating);

  useEffect(() => {
    if (!displayRatingInitialized.current) {
      displayRatingInitialized.current = true;
      prevDisplayRating.current = displayRating;
      return;
    }
    prevDisplayRating.current = displayRating;
  }, [displayRating]);

  const sortTypeOnChange = (updatedSortType) => {
    setSortOrder(updatedSortType);
  };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleSearchClear = async () => {
    await setSearchText("");
  };

  const handleSearchSubmit = async (searchValue) => {
    await setSearchText(searchValue);
  };

  const filteredSortOptions = SORT_OPTIONS.filter((option) => {
    if (!displayRating && option.value === SORT_ORDER_RATING_DESC_INT) {
      return false;
    }
    if (
      option.value === SORT_ORDER_NEXT_APPLICATION_INT &&
      (!includeNextActivitySettingLoaded || !includeNextActivityInOverview)
    ) {
      return false;
    }
    return true;
  });

  useEffect(() => {
    if (
      displayRatingInitialized.current &&
      prevDisplayRating.current === true &&
      !displayRating &&
      sortOrder === SORT_ORDER_RATING_DESC_INT
    ) {
      setSortOrder(0);
    }
  }, [displayRating, sortOrder, setSortOrder]);

  useEffect(() => {
    if (
      includeNextActivitySettingLoaded &&
      !includeNextActivityInOverview &&
      sortOrder === SORT_ORDER_NEXT_APPLICATION_INT
    ) {
      setSortOrder(0);
    }
  }, [
    includeNextActivitySettingLoaded,
    includeNextActivityInOverview,
    sortOrder,
    setSortOrder,
  ]);

  const sortOptionValue =
    filteredSortOptions.find((option) => option.value === sortOrder)?.value ||
    0;

  return {
    searchText,
    listView,
    sortOptionValue,
    showAdvancedFilter,
    sortTypeOnChange,
    handleSearchChange,
    handleSearchClear,
    handleSearchSubmit,
    toggleListView,
    handleShowAdvancedFilter,
    sortOptions: filteredSortOptions,
  };
};
